import { map } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as Actions from 'store/actions/index.ts'
import {
  getActivePackageKey,
  getActivePackagePriceInfos,
  getPriceInfosFromActivePackageInFilteredProducts
} from 'store/selectors'

const resetSelectionOnToggleCheapestPriceEpic = (actions$, state$) => actions$.pipe(
  ofType(Actions.configurator.TOGGLE_CHEAPEST_PRICE),
  map((action) => { // ToggleCheapestPriceAction
    const state = state$.value

    const activePackageKey = getActivePackageKey(state)

    if (action.payload.isToggled) {
      const priceInfos = getActivePackagePriceInfos(state)
      const priceInfosFromFilters = getPriceInfosFromActivePackageInFilteredProducts(state)

      const selection = {
        checkin: priceInfosFromFilters?.checkin
          ? priceInfosFromFilters.checkin
          : priceInfos.checkin !== ''
            ? priceInfos.checkin
            : undefined,
        departureCity: priceInfosFromFilters?.city
          ? priceInfosFromFilters.city
          : priceInfos.departureCity !== null
            ? priceInfos.departureCity
            : undefined,
        nights: priceInfosFromFilters?.nights
          ? priceInfosFromFilters.nights
          : priceInfos.nights !== null
            ? priceInfos.nights
            : undefined
      }

      return Actions.configurator.onConfiguratorSelectionChange(activePackageKey, selection, true, false, false)
    }

    const selection = {
      checkin: null,
      departureCity: null,
      nights: null
    }

    return Actions.configurator.onConfiguratorSelectionChange(activePackageKey, selection, true, true, false)
  })
)

export default resetSelectionOnToggleCheapestPriceEpic
